import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCircleInfo, faHexagonCheck, faOctagonXmark, faSealExclamation } from '@fortawesome/pro-solid-svg-icons'

export const CALLOUT_VARIANTS = ['info', 'warning', 'success', 'error'] as const

export type CalloutVariant = typeof CALLOUT_VARIANTS[number]

export type CalloutSize = 'xs' | 'sm'

export const CALLOUT_VARIANT_STYLES = {
  info: {
    icon: faCircleInfo,
    label: 'Melding, info',
    color: 'text-blue-500',
    backgroundColor: 'bg-blue-50',
  },
  success: {
    icon: faHexagonCheck,
    label: 'Melding, suksess',
    color: 'text-green-500',
    backgroundColor: 'bg-green-50',
  },
  warning: {
    icon: faSealExclamation,
    label: 'Melding, info',
    color: 'text-yellow-500',
    backgroundColor: 'bg-yellow-50',
  },
  error: {
    icon: faOctagonXmark,
    label: 'Melding, feil',
    color: 'text-red-500',
    backgroundColor: 'bg-red-50',
  },
} as const satisfies Record<CalloutVariant, { icon: IconDefinition, color: string, label: string, backgroundColor: string }>
